import React from 'react';
import './scss/wsp.scss';

const WhatsappFloat = () => {
  return (
    <a
      href="https://wa.me/56955206807"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea con nosotros en WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsappFloat;
